import { render, staticRenderFns } from "./BoardingPassCard.vue?vue&type=template&id=31290dc8"
import script from "./BoardingPassCard.vue?vue&type=script&lang=js"
export * from "./BoardingPassCard.vue?vue&type=script&lang=js"
import style0 from "./BoardingPassCard.vue?vue&type=style&index=0&id=31290dc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports